var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    model: {
      value: _vm.isVisibleDialog,
      callback: function callback($$v) {
        _vm.isVisibleDialog = $$v;
      },
      expression: "isVisibleDialog"
    }
  }, [_c('dialog-template', [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: -10,
      expression: "-10"
    }],
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l(['POST', 'GET'], function (method, idx) {
    return _c('option-panel', {
      directives: [{
        name: "m-b",
        rawName: "v-m-b",
        value: 10,
        expression: "10"
      }],
      key: idx,
      attrs: {
        "active": _vm.selectedMethod == method
      },
      on: {
        "click": function click($event) {
          return _vm.handleSelect(method);
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "textContent": _vm._s(method)
      },
      slot: "title"
    })]);
  }), 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }